import type { RailroadErrorProps } from './railroad';

export default function RailroadError({ message }: RailroadErrorProps) @{
  <pre class="error">{`Failed to render railroad diagram.\n${message}`}</pre>
}
